<template>
  <div class="playlists">
    <h2>Playlists</h2>
    <div class="">
      <div class="create">
        <b-button size="sm" v-on:click="createPlaylist()">Create new playlist</b-button>
      </div>
      <div class="list">
        <div class="playlist" v-for="(playlist, idx) in playlists" :key="idx">
          <div class="link">
            <router-link :to="{path: `/playlist/${playlist.key}`}"><span class="title">{{ playlist.name }}</span></router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .create {
    width: 100%;
    margin: 20px auto;
  }

  .list {
    .playlist {
      margin: 15px 0;
      a {
        color: #2c3e50;
      }
      .title {
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
</style>

<script>
import firebase from 'firebase';
import { auth, db, storage, currentUser } from '../firebaseConfig'

export default {
  name: 'playlists',
  data () {
    return {
      playlists: []
    }
  },
  created() {
    db.collection('playlists').where('active', '==', true).get().then((querySnapshot) => {
      querySnapshot.forEach(doc => {
        this.playlists.push({
          key: doc.id,
          name: doc.data().name,
        })
      })
    });
  },
  methods: {
    createPlaylist() {
      const name = prompt('Name');
      const timeStamp = new Date().getTime()

      db.collection('playlists').doc(String(timeStamp)).set({
        name: name,
        active: true,
        created: timeStamp,
        createdBy: currentUser.displayName,
      }).then(dbsnap => {
        console.log('all ok');
        this.$router.push({ name: 'playlist', params: { id: String(timeStamp) } });
      })
    }
  }
}
</script>
